import apiClient from './apiClient';

class AuthService {
  async me() {
    try {
      const data = await apiClient.get('/auth/me');
      return data;
    } catch (error) {

      throw new Error(
        error.response?.data?.error || 'Authentication failed'
      );
    }
  }
}

export const authService = new AuthService();